<template>
  <span
    class="status-pill"
    :class="[`status-pill--${variant}`, { 'status-pill--dense': dense }]"
  >
    {{ label }}
  </span>
</template>

<script>
export default {
  name: 'BaseStatusPill',
  props: {
    label: {
      type: String,
      required: true
    },
    variant: {
      type: String,
      required: false,
      default: 'neutral',
      validator: (value) => ['success', 'warning', 'error', 'info', 'primary', 'neutral'].includes(value)
    },
    dense: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style lang="scss">
.status-pill {
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 999px;
  white-space: nowrap;

  &--dense {
    font-size: 0.65rem;
    padding: 2px 8px;
  }

  &--success {
    background: rgba(76, 175, 80, 0.14);
    color: var(--v-successDarken-base);
  }

  &--warning {
    background: rgba(251, 140, 0, 0.14);
    color: var(--v-warningDarken-base);
  }

  &--error {
    background: rgba(235, 104, 104, 0.14);
    color: var(--v-errorDarken-base);
  }

  &--info {
    background: rgba(53, 168, 250, 0.14);
    color: var(--v-infoDarken-base);
  }

  &--primary {
    background: var(--v-primaryFaint-base);
    color: var(--v-primary-darken2);
  }

  &--neutral {
    background: rgba(116, 116, 116, 0.12);
    color: var(--v-neutralText-base);
  }
}
</style>
